import { motion } from "framer-motion";

const Loader = () => (
  <motion.div
    className="fixed inset-0 flex items-center justify-center bg-[#F8F5F0] z-50"
    initial={{ opacity: 1 }}
    exit={{ opacity: 0 }}
    transition={{ duration: 0.6, ease: "easeInOut" }}
  >
    <motion.div
      className="text-center"
      initial={{ opacity: 0, scale: 0.85 }}
      animate={{ opacity: [0, 1, 1, 0], scale: [0.85, 1, 1, 0.98] }}
      transition={{ duration: 1.5, times: [0, 0.25, 0.75, 1], ease: "easeInOut" }}
    >
      <div
        className="font-playfair text-9xl text-[#8B5E3C] font-semibold tracking-widest leading-none"
        style={{ fontStyle: "italic" }}
      >
        L
      </div>
      <div className="mt-3 text-xs tracking-[0.5em] text-[#8B5E3C]/50 uppercase font-manrope">
        Loos · Haltern am See
      </div>
      <div className="mt-4 flex justify-center">
        <motion.div
          className="h-px bg-[#8B5E3C]/30"
          initial={{ width: 0 }}
          animate={{ width: 80 }}
          transition={{ duration: 1.2, delay: 0.2 }}
        />
      </div>
    </motion.div>
  </motion.div>
);

export default Loader;
